import React from 'react';
import { Radar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler,
  Tooltip,
  Legend,
} from 'chart.js';

ChartJS.register(RadialLinearScale, PointElement, LineElement, Filler, Tooltip, Legend);

interface RadarChartData {
  label: string;
  value: number | null;
}

interface AnalyticsOverviewRadarChartProps {
  data1: RadarChartData[];
  label1: string;
  data2: RadarChartData[];
  label2: string;
  data3?: RadarChartData[];
  label3?: string;
}

const AnalyticsOverviewRadarChart: React.FC<AnalyticsOverviewRadarChartProps> = ({
  data1,
  label1,
  data2,
  label2,
  data3 = [],
  label3 = 'nuLogic Benchmark',
}) => {
  const radarData = {
    labels: data1.map(score => score.label),
    datasets: [
      {
        label: label1,
        data: data1.map(score => score.value),
        backgroundColor: 'rgba(135, 206, 250, 0.4)',
        borderColor: 'rgba(135, 206, 250, 1)',
        borderWidth: 2,
        pointBackgroundColor: 'rgba(135, 206, 250, 1)',
      },
      ...(data2.length > 0
        ? [
            {
              label: label2,
              data: data2.map(score => score.value),
              backgroundColor: 'rgba(50, 205, 50, 0.2)',
              borderColor: 'rgba(50, 205, 50, 1)',
              borderWidth: 2,
              pointBackgroundColor: 'rgba(50, 205, 50, 1)',
            },
          ]
        : []),
      ...(data3.length > 0
        ? [
            {
              label: label3,
              data: data3.map(score => score.value),
              backgroundColor: 'rgba(230, 101, 121, 0.18)',
              borderColor: 'rgba(230, 101, 121, 0.95)',
              borderWidth: 2,
              pointBackgroundColor: 'rgba(230, 101, 121, 0.95)',
            },
          ]
        : []),
    ],
  };

  const radarOptions = {
    scales: {
      r: {
        suggestedMin: 0,
        suggestedMax: 10,
        ticks: {
          stepSize: 2,
          showLabelBackdrop: false,
          color: '#666',
          font: {
            family: 'Poppins, sans-serif',
            size: 10,
          },
        },
        grid: {
          color: '#ccc',
        },
        angleLines: {
          color: '#ddd',
        },
        pointLabels: {
          color: '#333',
          font: {
            family: 'Poppins, sans-serif',
            size: 12,
          },
        },
      },
    },
    plugins: {
      legend: {
        position: 'bottom' as const,
        display: true,
        labels: {
          padding: 30,
          usePointStyle: true,
          pointStyle: 'circle',
          font: {
            family: 'Poppins, sans-serif',
            size: 14,
          },
        },
      },
    },

    layout: {
      padding: {
        bottom: 60, // <<< Add this!
      },
    },

    responsive: true,
    maintainAspectRatio: false,
  };

  return (
    <div style={{ width: '100%', height: '385px' }}>
      <Radar data={radarData} options={radarOptions} />
    </div>
  );
};

export default AnalyticsOverviewRadarChart;
